import {html, LitElement} from "lit";

// noinspection ES6UnusedImports
import {CustomerSelectWidget} from "../../crm/components/CustomerSelectWidget.js";
import {TodayTimeSummaryWidget} from "../../timesheet/components/TodayTimeSummaryWidget.js";
import {WeeklyTimeSummaryWidget} from "../../timesheet/components/WeeklyTimeSummaryWidget.js";
import {WeeklyTimePerCustomerWidget} from "../../timesheet/components/WeeklyTimePerCustomerWidget.js";
import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";
import {Router} from "@vaadin/router";
import {SettingsRepository} from "../SettingsRepository.js";
import ToastifyEs from "toastify-js/src/toastify-es.js";
import {ReactiveArray} from "../../lib/ReactiveArray.js";
import {TimeTool} from "../../lib/TimeTool.js";
import {TimesheetEntryRepository} from "../../timesheet/TimesheetEntryRepository.js";
import {DateTime} from "luxon";
import {TimesheetEntryLiveService} from "../../timesheet/TimesheetEntryLiveService.js";
import {AbstractTimesheetPage} from "../../timesheet/AbstractTimesheetPage.js";
import PlannedTimeService from "../../time-plan/PlannedTimeService.js";

export class HomePage extends AbstractTimesheetPage {

    static properties = {
        today: {reflect: true, type: String},
    }

    /**
     * @private {TimesheetEntryLiveService}
     */
    _liveService;

    /**
     * @private {PlannedTimeService}
     */
    _plannedTimeService;

    _dateInputDelay = 1000;

    _dateInputTimer = null;

    constructor() {
        super();
        this.today = TimeTool.dayAsString();
    }

    renderPage() {
        return html`
            <div class="container">
                <section>
                    <div class="row">
                        <div class="col-9"></div>
                        <div class="col-3"><input type="date" id="current-day" value="${this.today}" @change="${this._dateInputChanged}"></div>
                    </div>
                </section>
                <!-- x-customer-select-widget></x-customer-select-widget -->
                <div class="row">
                <x-today-time-summary-widget today="${this.today}" class="col-12 col-6-md"></x-today-time-summary-widget>
                <x-weekly-time-summary-widget dayinweek="${this.today}" class="col-12 col-6-md"></x-weekly-time-summary-widget>
                <x-weekly-time-per-customer-widget dayinweek="${this.today}" class="col-12 col-6-md"></x-weekly-time-per-customer-widget>
                </div>
            </div>
        `;
    }

    get startOfWeek() {
        return DateTime.fromISO(this.today).setZone('Europe/Berlin').startOf('week').toJSDate();
    }

    get endOfWeek() {
        return DateTime.fromISO(this.today).setZone('Europe/Berlin').endOf('week').toJSDate();
    }

    get startOfMonth() {
        return DateTime.fromISO(this.today).setZone('Europe/Berlin').startOf('month').toJSDate();
    }

    /**
     * This is the min date of start of week and start of month
     */
    get startOfQueryRange() {
        const startOfWeek = this.startOfWeek;
        const startOfMonth = this.startOfMonth;
        if (startOfWeek.getTime() <= startOfMonth.getTime()) {
            return startOfWeek;
        }
        return startOfMonth;
    }

    whenConnected() {
        this._liveService = new TimesheetEntryLiveService(this._entryRepo, this._entries);
        this._plannedTimeService = new PlannedTimeService(this._plannedTimeRepo, this._plannedTimes);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._liveService) {
            this._liveService.stopListening();
        }
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('today') && this._entryRepo) {
            this._updateServiceTimeRange();
            this._liveService.startListening();
        }
    }

    _dateInputChanged(evt) {

        let date = evt.target.value;

        let newWeekStart = DateTime.fromISO(date).setZone('Europe/Berlin').startOf('week').toJSDate();
        let newWeekEnd = DateTime.fromISO(date).setZone('Europe/Berlin').endOf('week').toJSDate();

        if (this._dateInputTimer !== null) {
            clearTimeout(this._dateInputTimer);
        }

        if (this.startOfWeek.getTime() === newWeekStart.getTime() && this.endOfWeek.getTime() === newWeekEnd.getTime() ) {
            this.today = date;
            return;
        }

        this._dateInputTimer = setTimeout(() => this.today = date, this._dateInputDelay);
    }

    _updateServiceTimeRange() {

        let currentRange = this._liveService.getTimeRange();
        const queryRangeStart = this.startOfQueryRange;

        if (!currentRange.length) {
            this._liveService.setTimeRange(queryRangeStart, this.endOfWeek);
            this._plannedTimeService.setTimeRange(queryRangeStart, this.endOfWeek);
            return;
        }

        if (currentRange[0].getTime() === this.startOfWeek.getTime() && currentRange[1].getTime() === this.endOfWeek.getTime()) {
            return;
        }

        this._liveService.setTimeRange(queryRangeStart, this.endOfWeek);
        this._plannedTimeService.setTimeRange(queryRangeStart, this.endOfWeek);

    }

}

customElements.define('x-home-page', HomePage);